module.exports = __webpack_public_path__ + "img/images4.36ad0004.jpeg";